import { stylesheet } from 'typestyle';

const styles = stylesheet({
  modalBackdrop: {
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    paddingBottom: '33px', // Overrides RAULv3 style
  },
  modalBottom: {
    alignItems: 'flex-end',
  },
  modalDialog: {
    pointerEvents: 'none',
    minWidth: '280px',
    margin: '32px',
  },
  modalContent: {
    padding: '32px !important',
  },
  modalBody: {
    fontSize: '16px !important',
    marginTop: '0px !important',
    overflowWrap: 'anywhere',
  },
  modalBodyGap: {
    marginBottom: '24px',
  },
  modalFooter: {
    padding: 0,
  },
  modalButtonContainer: {
    display: 'flex',
    width: '100%',
  },
  modalButton: {
    flex: '1',
    marginLeft: '8px',
    marginRight: '8px',
    $nest: {
      '&:first-child': {
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
});

export default styles;
